/* RecordMessage.js */
import { faMicrophone, faMicrophoneSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import React from 'react';

const RecordMessage = ({ tabHeight, handleRecordClick, isRecording }) => {

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: `calc(100vh - ${tabHeight})`,
                textAlign: 'center',
                flexDirection: 'column',
                padding: '0',
                margin: '0',
            }}
        >

            <Box sx={{ fontSize: '100px', cursor: 'pointer' }} onClick={handleRecordClick}>
                <FontAwesomeIcon className="blue-icon" icon={isRecording ? faMicrophoneSlash : faMicrophone} />
            </Box>

            <Typography variant="h5" gutterBottom sx={{ whiteSpace: 'pre-line' }}>
                {isRecording ?
                    'Now Recording.\nTap to Send.' : 'Microphone Off.\nTap to Record.'}
            </Typography>
        </Box>
    );
};

export default RecordMessage;
